<template>
  <div>
    <template v-for="link in researchLinkList">
      <a target="_blank" :href="link.Link" v-text="link.Name"></a>
    </template>
  </div>
</template>

<script>
    import Constants from "../Constants";
    import utils from "../Utils";
    import _ from "lodash";
    export default {
        name: "ResearchLink",
        props: {
        },
        mixins: [utils],
        data() {
            return {
              url:`${Constants.serverUrl}/api/research-link`,
              researchLinkList:[]
            };
        },
        created() {
        },
        mounted() {
          const _this = this
          _this.fetchData(this.url, '', 'researchLinkList','pageData.contentData', function (extraParams, response) {
            _this.researchLinkList = _.get(response, 'data.Value.pageData.contentData.researchLinkList', [])
          })
        },
        methods: {
        },
        computed: {
        },
    };
</script>
